type ConsentState = "granted" | "denied";

const ANALYTICS_GROUP = "C0002";
const ADS_GROUP = "C0004";

function ensureGtag(): NonNullable<Window["gtag"]> {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function gtag() {
      // gtag.js expects the Arguments object, not a rest array
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer?.push(arguments);
    };
  }
  return window.gtag;
}

function toConsentState(granted: boolean): ConsentState {
  return granted ? "granted" : "denied";
}

export function updateGoogleConsent(): void {
  const activeGroups = window.OnetrustActiveGroups ? window.OnetrustActiveGroups.split(",") : [];
  const analyticsGranted = activeGroups.includes(ANALYTICS_GROUP);
  const adsGranted = activeGroups.includes(ADS_GROUP);
  const analyticsStorage = toConsentState(analyticsGranted);
  const adsStorage = toConsentState(adsGranted);

  ensureGtag()("consent", "update", {
    analytics_storage: analyticsStorage,
    ad_storage: adsStorage,
    ad_user_data: adsStorage,
    ad_personalization: adsStorage,
  });

  window.dataLayer?.push({
    event: "onetrust_consent_applied",
    consent_analytics: analyticsStorage,
    consent_ads: adsStorage,
  });
}

let isListenerAttached = false;

export function optanonWrapper(): void {
  updateGoogleConsent();

  if (!isListenerAttached && window.OneTrust && typeof window.OneTrust.OnConsentChanged === "function") {
    window.OneTrust.OnConsentChanged(updateGoogleConsent);
    isListenerAttached = true;
  }
}
